export const playerTypes = [
  { id: 1, value: 'guest', label: 'Guest', translation: 'guest' },
  { id: 2, value: 'guest to member', label: 'Guest To Member', translation: 'guestToMember' },
  { id: 3, value: 'member', label: 'Member', translation: 'member' },
  { id: 4, value: 'partner', label: 'Partner', translation: 'partner' },
  { id: 5, value: 'total', label: 'Total', translation: 'total' },
]

export const buttonsTypes = {
  VOUCHER: 'voucher',
  PARTNERSHIP: 'partnership',
}

export const filtersMap = {
  ACTIVE: 'active',
  INACTIVE: 'inActive',
  EXPIRED: 'expired',
  CANCELED: 'canceled',
}
